<!-- <div class="card">
    <div class="card-body">
        <p class="text-danger font-weight-bold mb-0">Consumption overview</p>
        <div class="progress progress--stacked">
            <span *ngFor="let item of devices"
                [ngStyle]="{ 'width': ((item.consumption/total)*100)+'%','background-color' : item.color}"></span>
        </div>
        <span *ngFor="let item of devices" class="device_name">
            <span [ngStyle]="{'color' : item.color}">●</span> {{item.device_name}}
        </span>
    </div>
</div> -->

<!-- <div class="row">
    <div class="col-12">
        <p class="text-danger font-weight-bold mb-0">Consumption overview</p>
    </div>
    <div class="col-12 d-flex">
        <div *ngFor="let item of devices;let i = index" class="main_progress">
            <div class="card">
                <div class="card-body">
                    <div id="{{'container' + i}}" class="progress_circle"></div>
                </div>
                <span>{{item.device_name}}</span>
            </div>
        </div>
    </div>
</div> -->



<div class="carousel slide multi-item-carousel" id="theCarousel" data-ride="carousel" data-type="multi">
    <div class="carousel-inner row w-100 mx-auto">
        <div class="carousel-item col-md-4 col-4" *ngFor="let item of devices;let first=first; let i=index" [attr.data-slide-to]="i" [ngClass]="{active: first}">
            <div class="card device_card d-block">
                <div class="card-body">
                    <div id="{{'container' + i}}" class="progress_circle"></div>
                    <div class="slide-text">
                        <p class="text-center font-weight-bold mt-3">{{item.device_name}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>





<!-- 
<div class="carousel-wrap">
    <div class="owl-carousel">
        <div class="item"><img src="http://placehold.it/150x150"></div>
        <div class="item"><img src="http://placehold.it/150x150"></div>
        <div class="item"><img src="http://placehold.it/150x150"></div>
        <div class="item"><img src="http://placehold.it/150x150"></div>
        <div class="item"><img src="http://placehold.it/150x150"></div>
        <div class="item"><img src="http://placehold.it/150x150"></div>
        <div class="item"><img src="http://placehold.it/150x150"></div>
        <div class="item"><img src="http://placehold.it/150x150"></div>
        <div class="item"><img src="http://placehold.it/150x150"></div>
        <div class="item"><img src="http://placehold.it/150x150"></div>
        <div class="item"><img src="http://placehold.it/150x150"></div>
        <div class="item"><img src="http://placehold.it/150x150"></div>
    </div>
</div> -->